export const DOWNTIME_BRANCH = "DOWNTIME_BRANCH";
export const SUB_DOWNTIME_BRANCH = "SUB_DOWNTIME_BRANCH";
export const UPTIME_BRANCH = "UPTIME_BRANCH";
